import { lazy } from 'react';

const BusinessIntelligence = {
  Helmet: lazy(() => import('./components/Helmet')),
  Reporting: {
    Layout: lazy(() => import('./containers/Reporting')),
    Report: lazy(() => import('./containers/Reporting/pages/ReportType/Report')),
    ReportType: lazy(() => import('./containers/Reporting/pages/ReportType/ReportType')),
    List: lazy(() => import('./containers/Reporting/pages/ReportListPage')),
  },
  Dashboard: {
    Layout: lazy(() => import('./containers/Dashboard')),
    MainPage: lazy(() => import('./containers/Dashboard/pages/MainPage')),
    EditVisualizationPage: lazy(() => import('./containers/Dashboard/pages/EditVisualizationPage')),
    SinglePage: lazy(() => import('./containers/Dashboard/pages/SinglePage')),
  },
};

export default BusinessIntelligence;
